import useSelects, { ValueEntries } from "hooks/useSelects";
import { createContext, ReactNode, useContext } from "react";

const ContractDetailsSelectsContext = createContext<SelectState[]>([]);

const ContractDetailsSelectsProvider = ({
  values,
  selectMetadata,
  children,
}: {
  values?: ValueEntries;
  selectMetadata: Pick<SelectState, "placeholder" | "filterKey">[];
  children: ReactNode;
}) => {
  const { selectStates } = useSelects({ values, selectMetadata });

  return (
    <ContractDetailsSelectsContext.Provider value={selectStates}>
      {children}
    </ContractDetailsSelectsContext.Provider>
  );
};

export const useContractDetailsSelects = () => {
  const selectStates = useContext(ContractDetailsSelectsContext);
  if (!selectStates) {
    throw new Error(
      "useContractDetailsSelects must be used within ContractDetailsSelectsProvider"
    );
  }
  return selectStates;
};
export default ContractDetailsSelectsProvider;
